import { render } from "./level-card.vue?vue&type=template&id=ec04adfc&scoped=true&ts=true"
import script from "./level-card.vue?vue&type=script&lang=ts"
export * from "./level-card.vue?vue&type=script&lang=ts"

import "./level-card.vue?vue&type=style&index=0&id=ec04adfc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec04adfc"]])

export default __exports__